var NEWSLETTER = {
	onLoad: function() {
		var validated = false;

		$('.button.newsletter').click(function(e){
			$(this).attr('disabled', 'disabled');
			$('#mc-embedded-subscribe-form .error-messages').html('');
			if ( validated === true ) {
				validated = false;
				return;
			}
			e.preventDefault();
			
			var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			var zipRegex = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
			var errors = [];
			var email = $('form#mc-embedded-subscribe-form #mail').val();
			var zipCode = $('form#mc-embedded-subscribe-form #zip_code').val();

			if ( ( email === '' ) || ( zipCode === '' ) ) {
				// EMAIL ERRORS
				if ( email === '' ) {
					errors.push('Please enter your email.');
				} else {
					if ( emailRegex.test(email) ) {
						console.log('valid email');
					} else {
						errors.push('Please enter a valid email address.');
					}
				}

				// ZIPCODE ERRORS
				if ( zipCode === '' ) {
					errors.push('Please enter your zip code.');
				} else {
					if ( zipRegex.test(zipCode) ) {
						console.log('valid zipcode');
					} else {
						errors.push('Please enter a valid zipcode.');
					}
				}
			} else if ( ( email !== '' ) && ( zipCode !== '' ) ) {
				// EMAIL ERRORS
				if ( emailRegex.test(email) ) {
					console.log('valid email');
				} else {
					errors.push('Please enter a valid email address.');
				}

				// ZIPCODE ERRORS
				if ( zipRegex.test(zipCode) ) {
					console.log('valid zipcode');
				} else {
					errors.push('Please enter a valid zipcode.');
				}
			} else {
				validated = true;
				$('.button.newsletter').trigger('click');
			}

			if ( errors.length > 0 ) {
				var errorNumber = errors.length;
				for (i=0; i < errorNumber; i++) {
					var appendError = '<p class="error-text">' + errors[i] + '</p>';
					$('#mc-embedded-subscribe-form .error-messages').append(appendError);
				}
			} else {
				console.log('no errors');
				validated = true;
				$('#mc-embedded-subscribe-form').submit();
				// GA TRIGGER
				ga('send', 'event', 'Newsletter Sign Up', 'Sign Up', 'Newsletter');
				$('form#mc-embedded-subscribe-form #mail').val('');
				$('form#mc-embedded-subscribe-form #zip_code').val('');
			}
			$(this).removeAttr('disabled');

		});
	}
}

$(document).ready( function(){
	NEWSLETTER.onLoad();
});